import { useState, useEffect }      from 'react'
import SubscriptionModal            from './SubscriptionModal.js' 

const SubscriptionDetailsItem = ( { user, subscription, paymentMethod } ) => {
    const [isOpen, setIsOpen] = useState(false)
    
    const toggle = () => setIsOpen(!isOpen)

    return (
        <>
            <button
                className="profile-menu-item profile-menu-item-clickable"
                onClick={toggle}
            >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" className="profile-menu-icon">
                    <rect x="2" y="5" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="2"/>
                    <path d="M2 10h20" stroke="currentColor" strokeWidth="2"/>
                </svg>
                Subscription Details
            </button>

            { isOpen && <SubscriptionModal user={user} subscription={subscription} paymentMethod={paymentMethod} toggleClose={toggle}/> }
        </>
    )
}

export default SubscriptionDetailsItem